import { Button, Col, Form, Input, InputNumber, Row, Select, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { renderConditionalOptions } from '../../../utilities/formHelpers';

const { Option } = Select;
const { Text } = Typography;

function AddCreditsForm(props) {
  const { initialValues, onSubmit, status, type } = props;
  const [showCustomReason, setCustomReason] = useState(false);
  const [isPromoCustom, setIsPromoCustom] = useState(false);

  const [form] = Form.useForm();

  const reasonListMenu = [
    {
      value: 'OD_WINNER',
      name: 'OD Winner',
    },
    {
      value: 'ALUMNI',
      name: 'Alumni',
    },
    {
      value: 'CUSTOM',
      name: 'Other',
    }
  ].map((option) => <Option value={option.value}>{option.name}</Option>);

  useEffect(() => {
    form.setFieldsValue(initialValues);
  }, [initialValues]);

  function setPromoCode(reason) 
  {
    // construct promo code as REASON_<LEARNER_ID>_<DATETIME>
    let defaultCode = `${reason}_${initialValues.learner_id}`;
    let today = new Date();
    let formatted_date = today.toISOString().replace(/\D/g,'');
    defaultCode += `_${formatted_date}`
    form.setFieldsValue({ code: defaultCode.toUpperCase() });
  }

  function onPromoCodeChange(e) {
    form.setFieldsValue({ code: e.target.value.toUpperCase() });  
  }

  function onReasonChange(e){
    let reason = form.getFieldValue('reason')
    if(reason != 'CUSTOM'){    
      setCustomReason(false);
      setPromoCode(reason);
    }else{
      setCustomReason(true);
    }
  }

  function onCustomReasonChange(values) {
    let reason = form.getFieldValue('customReason');
    // replace whitespaces with underscores
    reason = reason.replace(/ /g,"_");
    // allow only alphanumeric characters and underscrores for custom reason, remove all other characters
    reason = reason.replace(/[^A-Z0-9_]/ig, "")
    form.setFieldsValue({ customReason: reason.toUpperCase() });
    setPromoCode(reason);
  }

  function customPromoCheckHandler(value){
    const isPromoCustom = form.getFieldValue("isPromoCustom");
    setIsPromoCustom(isPromoCustom)
  }

  return (
    <Form
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 14 }}
      onFinish={onSubmit}
      initialValues={initialValues}
      form={form}
    >
      <Form.Item
        label="Email"
        name="email"
      >
        <Input disabled={true} />
      </Form.Item>
      <Form.Item
        label="Custom Promo Code"
        name="isPromoCustom"
        rules={[{ required: true }]}
      >
        <Select onChange={(value) => customPromoCheckHandler(value)} defaultValue={initialValues.isPromoCustom}>{renderConditionalOptions()}</Select>
      </Form.Item>
      <Form.Item
        label="Reason"
        name="reason"
        hidden={isPromoCustom}
        rules={[{ required: !isPromoCustom, message: 'Please select reason!' }]}
      >
        <Select onChange={(value) => onReasonChange(value)} placeholder="Select a Reason">{reasonListMenu}</Select>
      </Form.Item>
      <Form.Item
        label="Custom Reason"
        name="customReason"
        hidden={!showCustomReason || isPromoCustom}
        rules={[ { required: showCustomReason, whitespace:false, message: 'Please input promo code!' }]}
      >
        <Input onChange={(value) => onCustomReasonChange(value)} min={0} defaultValue={initialValues.customReason}/>
      </Form.Item>
      <Form.Item
        label="Promo Code"
        name="code"
        rules={[ { required: true, message: 'Please input promo code!' }]}
      >
        <Input onChange={(value) => onPromoCodeChange(value)} disabled={!isPromoCustom} min={0} defaultValue={initialValues.code}/>
      </Form.Item>
      <Form.Item
        label="Credit amount"
        name="discountValue"
        rules={[ { required: true, message: 'Please input credit amount!' }]}
      >
        <InputNumber min={0} defaultValue={initialValues.discountValue}/>
      </Form.Item>
      {status.type === 'SUCCESS' ? (
        <Text type="success">Successful!</Text>
      ): status.type === 'ERROR' ? (
        <Text type="danger">{status.message}</Text>
      ) : null}
      <Row justify="end" gutter={12}>
        <Col>
          <Button type="primary" htmlType="submit">
            {type}
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

export default AddCreditsForm;
